import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg width="86.356" height="86.357" viewBox="0 0 86.356 86.357">
    <path
      id="dashboard"
      d="M3,50.976H41.381V3H3ZM3,89.357H41.381V60.571H3Zm47.976,0H89.356V41.381H50.976ZM50.976,3V31.786H89.356V3Z"
      transform="translate(-3 -3)"
      fill="#757e8d"
    />
  </svg>,
  'DashboardIcon',
);
